module.exports = "/static/assets/e771d810e0467436657c918dc23b9b80.gif";